import { cloneDeep } from 'lodash';
import solveExpression from './solveExpression';

function getTotals(items, columns) {
  let props = {};

  columns.forEach(column => {
    if (column?.total) {
      props[column.fld] = 0;
    }
  });

  return items.reduce((acc, prev) => {
    Object.keys(props).forEach(prop => {
      const fld = columns.find(col => col.fld === prop);
      if (fld?.formula) {
        acc[prop] += solveExpression({
          expression: fld?.formula,
          variables: prev
        });
      } else {
        acc[prop] += prev?.[prop] ?? 0;
      }
    });

    return acc;
  }, cloneDeep(props));
}

export default getTotals;
